// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deck-cookie-notice {
  position: relative;
  height: 100%;
  text-align: center;
}
.deck-cookie-notice-inner {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.deck-cookie-notice-content {
  max-width: 420px;
  margin: 0 auto;
  text-align: left;
}
.deck-cookie-notice-link {
  white-space: nowrap;
}
.deck-cookie-notice-btn {
  margin-top: 1rem;
}
.nkl-deck-cookie-notice-close-btn {
  position: absolute;
  right: -16px;
  top: -16px;
  width: 20px;
  height: 20px;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
}
.nkl-deck-cookie-notice-close-icon {
  width: 100%;
  fill: currentColor;
}
.ant-drawer.ant-drawer-bottom.ant-drawer-open {
  z-index: 1002;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
